import { useQuery } from "@tanstack/react-query";

import { useTenantConfig } from "@/hooks/use-tenant-config";
import { postedInClassroomApi, postedInClassroomQueryKey } from "@/lib/api/classroomReferences";

/**
 * One read of Posted in Classroom, shared by the group and whatever must know
 * whether it holds any. A tenant with no Classroom journey (Murtada) never
 * asks: `absent` says so once tenant configuration has resolved.
 */
export function usePostedInClassroom(courseId: string) {
  const { classroomReferencesEnabled, memberStatus } = useTenantConfig();
  const group = useQuery({
    queryKey: postedInClassroomQueryKey(courseId),
    queryFn: () => postedInClassroomApi.get(courseId),
    enabled: classroomReferencesEnabled,
    retry: false,
  });
  return { group, enabled: classroomReferencesEnabled, absent: memberStatus === "resolved" && !classroomReferencesEnabled };
}
